import { render, staticRenderFns } from "./cta2.component.vue?vue&type=template&id=92489a6c"
import script from "./cta2.component.vue?vue&type=script&lang=js"
export * from "./cta2.component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports